import { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../components/Header';
import RenderTiptap from '../components/Editor/RenderTiptap';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

function parseConteudo(c) {
  if (!c) return null;
  if (typeof c === 'object') return c;
  try { return JSON.parse(c); } catch (_) { return null; }
}

export default function DocumentoView() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const trilhaId = sp.get('trilha');
  const itemId = sp.get('item');
  const navigate = useNavigate();
  const { temPermissao } = useAuth();
  const podeEditar = temPermissao('editar_documento');

  const [doc, setDoc] = useState(null);
  const [anexos, setAnexos] = useState([]);
  const [lido, setLido] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [marcando, setMarcando] = useState(false);

  useEffect(() => {
    setCarregando(true);
    api.get(`/documentos/${id}`)
      .then(({ data }) => { setDoc(data.documento); setAnexos(data.anexos || []); setLido(data.lido); })
      .catch(err => setErro(err.response?.data?.error || 'Erro ao carregar documento'))
      .finally(() => setCarregando(false));
  }, [id]);

  async function marcarLido() {
    setMarcando(true);
    try {
      await api.post(`/documentos/${id}/lido`);
      setLido(true);
      Swal.fire({ icon: 'success', title: 'Leitura registrada!', timer: 1400, showConfirmButton: false });
    } catch (_) {
      Swal.fire('Ops', 'Não foi possível registrar a leitura.', 'error');
    } finally {
      setMarcando(false);
    }
  }

  async function concluirAula() {
    try {
      await api.post(`/trilhas/${trilhaId}/itens/${itemId}/concluir`);
      navigate(`/academia/trilhas/${trilhaId}`);
    } catch (_) {
      Swal.fire('Ops', 'Não foi possível concluir a aula.', 'error');
    }
  }

  async function excluir() {
    const r = await Swal.fire({ icon: 'warning', title: 'Excluir documento?', showCancelButton: true, confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', confirmButtonColor: '#C62828' });
    if (!r.isConfirmed) return;
    await api.delete(`/documentos/${id}`);
    navigate('/documentos/manuais');
  }

  const conteudo = parseConteudo(doc?.conteudo);

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 860 }}>
        <Link to={trilhaId ? `/academia/trilhas/${trilhaId}` : '/documentos/manuais'} className="doc-voltar">
          <i className="bi bi-arrow-left"></i> {trilhaId ? 'Trilha' : 'Documentos'}
        </Link>

        {carregando && <div>Carregando…</div>}
        {erro && <div className="erro">{erro}</div>}

        {doc && (
          <article className="conteudo-card doc-artigo">
            <div className="doc-artigo-cab">
              <div>
                <div className="doc-card-tipo">{doc.categoria_nome}</div>
                <h1>{doc.titulo}</h1>
                {doc.resumo && <p className="doc-artigo-resumo">{doc.resumo}</p>}
              </div>
              {podeEditar && (
                <div className="doc-artigo-acoes">
                  <Link to={`/admin/documentos/${doc.id}/editar`} className="btn-centrao-laranja"><i className="bi bi-pencil"></i></Link>
                  <button className="doc-btn-excluir" onClick={excluir} title="Excluir"><i className="bi bi-trash"></i></button>
                </div>
              )}
            </div>

            {doc.youtube_id && (
              <div className="doc-video">
                <iframe
                  src={`https://www.youtube.com/embed/${doc.youtube_id}`}
                  title={doc.titulo}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}

            {conteudo && <RenderTiptap conteudo={conteudo} />}

            {anexos.length > 0 && (
              <div className="doc-anexos">
                <h3>Anexos</h3>
                {anexos.map(a => (
                  <a key={a.id} href={a.url} target="_blank" rel="noreferrer" className="doc-anexo">
                    <i className="bi bi-paperclip"></i> {a.nome}
                  </a>
                ))}
              </div>
            )}

            <div className="doc-leitura">
              {trilhaId && itemId ? (
                <button className="btn-centrao" onClick={concluirAula}>
                  <i className="bi bi-check2-circle me-1"></i> Concluir aula e voltar à trilha
                </button>
              ) : lido ? (
                <div className="doc-leitura-ok"><i className="bi bi-check-circle-fill"></i> Você já confirmou a leitura.</div>
              ) : (
                <button className="btn-centrao" onClick={marcarLido} disabled={marcando}>
                  <i className="bi bi-check2-circle me-1"></i> {marcando ? 'Registrando…' : 'Li e entendi'}
                </button>
              )}
            </div>
          </article>
        )}
      </main>
    </>
  );
}
